import { CRUD, CrudModel } from '../../classes'
import { EstimateCategoryData, EstimateCategoryStatus } from './estimate-category.data'

@CRUD({
  base: '/crud/estimate-categories',
})
export class EstimateCategoryModel extends CrudModel {
  name: string
  parentId: string | null
  status: EstimateCategoryStatus
  createdBy?: string | { id: string, name?: string }
  updatedBy?: string | { id: string, name?: string }
  depth = 0

  constructor(data?: EstimateCategoryData) {
    super(data, true)
  }

  override toJSON() {
    return Object.assign(super.toJSON(), {
      name: this.name,
      parentId: this.parentId,
      status: this.status,
      createdBy: typeof this.createdBy === 'string' ? this.createdBy : this.createdBy?.id,
      updatedBy: typeof this.updatedBy === 'string' ? this.updatedBy : this.updatedBy?.id,
    })
  }

  get isActive() {
    return this.status === EstimateCategoryStatus.ACTIVE
  }
}
